////////////////ProductConfig.js

import g from '@/model/language'
import { IsRights, Modulel, Permission, Clone, ToComponentData, ToSubmitEntity, CheckByConfig, ToSubmitData, CheckByEntity, $Urlpath } from '@/config/config'
import { userRequest } from '@/request/user'
import {
    RemoveFieldItem
} from '@/lf'

import { ProductRequest } from '@/request/Warehouse'
import { ProductTypeRequest } from '@/request/Warehouse'

import { ObjectCheck, GetFieldItem } from '@/lf'
import '@/lf'

export function InitShoppingPage(StoreName, GNFunc) {
    var dc = { data: {} };

    var defaultStoreName = 'ShoppingPage'
    if (StoreName) {
        defaultStoreName = StoreName;
    }

    var GN = function(storeName) {
        return defaultStoreName + '$' + storeName;
    }

    if (GNFunc) {
        GN = GNFunc;
    }

    defaultStoreName = GN('ShoppingPage')
    var vueObj = window.rootVue;
    var vueState = vueObj.$store.state;
    var state = vueObj.$store.state[defaultStoreName];

    var ShoppingPage = {
        Title: g('$Products管理1'),
        storeName: defaultStoreName,
        GN: GN,
        AddModuleShow: false,
        AddModalName: g('$新增Products'),
        IsInit: false,
        typeList:[1],
        Search: //page-search-table 配置
            [

            // { nickName: g('$所属客户'), field: 'UsersID', type: 'Select', error: '', IsNotEdit: false, isRequired: true, j: { rex: 'n', tips: g("${所属客户}为必填") }, forSelectStoreName: GN('CustomerUsersID') },
            { nickName: g('$类型'), field: 'ProductType', type: 'Select', error: '', isRequired: true, j: { rex: 'n', tips: g("${ProductType}为必填") }, forSelectStoreName: GN('ProductProductTypeID') },
            { nickName: g('$SKU'), field: 'SKU', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${SKU}为必填") } },
            {
              nickName: g('$状态'),
              field: 'Status',
              type: 'Select',
              error: '',
              initValue: 1,
              isRequired: true,
              j: { rex: 'n', tips: g("${状态}为必填") },
              forSelectStoreName: ('ProductStatus')
          },
            // { nickName: g('$产品条形码'), field: 'ProductCode', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${产品条形码}为必填") } },
            // { nickName: g('$产品中文名'), field: 'CnName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${产品中文名}为必填") } },
            // { nickName: g('$产品英文名'), field: 'EnName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${产品英文名}为必填") } },
            // { nickName: g('$海关编码'), field: 'CustomcCode', type: 'String', error: '' },
          
        ],
        Table: {
            OnSelectionChange: function(selection) {
                window.rootVue.$set(vueState, GN('TableSelectCheckbox'), selection)
            },
            TableColumns: [

                {
                    nickName: ' ',
                    field: '',
                    type: 'selection',
                    Width: 50,
                    fixed: 'left',
                    initValue: false,
                    forSelectStoreName: GN('TableSelectCheckbox'),
                    Selectable(row, index) {
                        return true;
                    }
                },
                // {
                //     nickName: g('$所属客户'),
                //     field: 'UsersID',
                //     type: 'AddString',
                //     AddString(data) {
                //         return data.User ? data.User.Customer.Name + "-" + data.User.Customer.CusCode : '';
                //     }
                // },

                { nickName: g('$产品图片'), field: 'ProductUrl', type: 'Image', error: '', isRequired: true, j: { rex: 'w', tips: g("${SKU}为必填") }, class: 'max100' },

                { nickName: g('$SKU'), field: 'SKU', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${SKU}为必填") } },
                { nickName: g('$重量'), field: 'P_Weight', type: 'String', error: '' },
                // {
                //     nickName: g('$类型'),
                //     field: 'ProductTypeID',
                //     type: 'AddString',
                //     AddString(data) {
                //         return data.ProductType.EnName + "-" + data.ProductType.CnName
                //     }
                // },
                { nickName: g('$产品条形码'), field: 'ProductCode', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${产品条形码}为必填") } },
                { nickName: g('$产品中文名'), field: 'CnName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${产品中文名}为必填") } },
                { nickName: g('$产品英文名'), field: 'EnName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${产品英文名}为必填") } },
                { nickName: g('$采购价'), field: 'PurchasePrice', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${采购价}为必填") } },
                {
                    nickName: g('$销售价'),
                    field: 'SalesPrice',
                    type: 'AddString',
                    AddString(data) {
                        return data.SalesPrice + (data.User ? "(" + data.User.Account.Currency.EnName + ")" : '');
                    }
                },
                // { nickName: g('$固定运费'), field: 'FixedFreight', type: 'AddString',AddString(data){
                //     return data.FixedFreight +  (data.User?"("+ data.User.Account.Currency.EnName+")" :'');
                // }},
                { nickName: g('$状态'), field: 'Status', type: 'Select', error: '', isRequired: true, j: { rex: 'n', tips: g("${状态}为必填") }, forSelectStoreName: ('ProductStatus') },
                { nickName: g('$带电'), field: 'IsBattery', type: 'Select', error: '', isRequired: true, j: { rex: 'n', tips: g("${状态}为必填") }, forSelectStoreName: ('IsAndNot') },

                { nickName: g('$缺货'), field: 'CustomerQtyLess', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${状态}为必填") }},

                { nickName: g('$在途'), field: 'CustoerWaitting', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${状态}为必填") }},




                // { nickName: g('$修改时间'), field: 'ModifyTime', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${修改时间}为必填") } },
                { nickName: g('$操作'), field: 'Operation', type: 'Operation', initValue: '', Width: 300, Fixed: 'right', ClassName: 'FixedRightBorder product' },
            ],
            TableIsEdit: true,
            PageSize: 10,
            OnPageChange: function(Index) {
                state.SearchEntity.PageIndex = Index;
                state.SearchPageData();
            },
            OnPageSizeOpts: function(pageSize) {
                state.SearchEntity.PageIndex = 1;
                state.SearchEntity.PageSize = pageSize;
                state.SearchPageData();
            },
            TableRowButtons: function() {

                var store = state
                if (store.Table.$TableRowButtons) {
                    return store.Table.$TableRowButtons
                }

                var arr = [];
                if (IsRights(Modulel.ProductManage, Permission.Update)) {
                    arr.push({
                        nickName: g('$修改'),
                        buttonType: 'primary',
                        type: 'Button',
                        forClick: function(data) {
                            if (store.ToUpdate) {
                                store.ToUpdate(data)
                            } else {
                                vueObj.$router.push('/AddProduct/' + data.ID)
                            }

                        }
                    })



                } else if (IsRights(Modulel.ProductManage, Permission.See)) {
                    arr.push({
                        nickName: g('$查看'),
                        buttonType: 'primary',
                        type: 'Button',
                        forClick: function(data) {
                            if (store.ToUpdate) {
                                store.ToUpdate(data)
                            } else {
                                vueObj.$router.push('/AddProduct/' + data.ID)
                            }
                        }
                    })
                }

  if (true) {
    arr.push({
      nickName: g('$打印标签'),
      buttonType: 'primary',
      type: 'Button',
      CheckShow: function (data) {
        if  (IsRights(Modulel.ProductManage, Permission.See)) {
          return true;
        }
        return false;

      },
      forClick: function (data) {
        if (store.PrintProductIDS) {
          store.PrintProductIDS(data)
        }
      }

    })
  }

                if (IsRights(Modulel.ProductManage, Permission.UpdateStatus)) {



                    arr.push({
                        nickName: g('$设置禁用'),
                        buttonType: 'warning',
                        type: 'ConfirmButton',
                        CheckShow: function(data) {
                            if (data.Status == 1) {
                                return true;
                            }
                            return false;
                        },
                        forClick: function(data) {
                            ProductRequest.SetProductStatus(function(d) {
                                if (d.Message == "OK") {
                                    if (store.ToUpdateStatus) {
                                        store.ToUpdateStatus(data, d)
                                    } else {
                                        store.Table.OnPageChange(store.SearchEntity.PageIndex, vueObj)
                                    }
                                    vueObj.$message.success(g("$操作成功"))
                                } else {
                                    vueObj.$message.error(d.Message)
                                }
                            }, data.ID, 2)
                        }
                    })

                    arr.push({
                        nickName: g('$设置启用'),
                        buttonType: 'warning',
                        type: 'ConfirmButton',
                        CheckShow: function(data) {
                            if (data.Status == 2) {
                                return true;
                            }
                            return false;
                        },
                        forClick: function(data) {
                            ProductRequest.SetProductStatus(function(d) {
                                if (d.Message == "OK") {
                                    if (store.ToUpdateStatus) {
                                        store.ToUpdateStatus(data, d)
                                    } else {
                                        store.Table.OnPageChange(store.SearchEntity.PageIndex, vueObj)
                                    }
                                    vueObj.$message.success(g("$操作成功"))
                                } else {
                                    vueObj.$message.error(d.Message)
                                }
                            }, data.ID, 1)
                        }
                    })


                }

                vueObj.$set(store.Table, '$TableRowButtons', arr)
                return store.Table.$TableRowButtons;

            },
        },

        Table2: {
          OnSelectionChange: function(selection) {
              window.rootVue.$set(vueState, GN('TableSelectCheckbox'), selection)
          },
          TableColumns: [

            {
                nickName: ' ',
                field: '',
                type: 'selection',
                Width: 50,
                fixed: 'left',
                initValue: false,
                forSelectStoreName: GN('TableSelectCheckbox'),
                Selectable(row, index) {
                    return true;
                }
            },
            // {
            //     nickName: g('$所属客户'),
            //     field: 'UsersID',
            //     type: 'AddString',
            //     AddString(data) {
            //         return data.User ? data.User.Customer.Name + "-" + data.User.Customer.CusCode : '';
            //     }
            // },

            { nickName: g('$产品图片'), field: 'ProductUrl', type: 'Image', error: '', isRequired: true, j: { rex: 'w', tips: g("${SKU}为必填") }, class: 'max100' },

            { nickName: g('$SKU'), field: 'SKU', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${SKU}为必填") } },
            { nickName: g('$重量'), field: 'P_Weight', type: 'String', error: '' },
            // {
            //     nickName: g('$类型'),
            //     field: 'ProductType',
            //     type: 'AddString',
            //     AddString(data) {
            //         return data.ProductType.EnName + "-" + data.ProductType.CnName
            //     }
            // },
            { nickName: g('$产品条形码'), field: 'ProductCode', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${产品条形码}为必填") } },
            { nickName: g('$产品中文名'), field: 'CnName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${产品中文名}为必填") } },
            { nickName: g('$产品英文名'), field: 'EnName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${产品英文名}为必填") } },
            { nickName: g('$采购价'), field: 'PurchasePrice', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${采购价}为必填") } },
            {
                nickName: g('$销售价'),
                field: 'SalesPrice',
                type: 'AddString',
                AddString(data) {
                    return data.SalesPrice + (data.User ? "(" + data.User.Account.Currency.EnName + ")" : '');
                }
            },
            // { nickName: g('$固定运费'), field: 'FixedFreight', type: 'AddString',AddString(data){
            //     return data.FixedFreight +  (data.User?"("+ data.User.Account.Currency.EnName+")" :'');
            // }},
            { nickName: g('$状态'), field: 'Status', type: 'Select', error: '', isRequired: true, j: { rex: 'n', tips: g("${状态}为必填") }, forSelectStoreName: ('ProductStatus') },
            { nickName: g('$带电'), field: 'IsBattery', type: 'Select', error: '', isRequired: true, j: { rex: 'n', tips: g("${状态}为必填") }, forSelectStoreName: ('IsAndNot') },

            { nickName: g('$缺货'), field: 'CustomerQtyLess', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${状态}为必填") }},

            { nickName: g('$在途'), field: 'CustoerWaitting', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${状态}为必填") }},




            // { nickName: g('$修改时间'), field: 'ModifyTime', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${修改时间}为必填") } },
            { nickName: g('$操作'), field: 'Operation', type: 'Operation', initValue: '', Width: 300, Fixed: 'right', ClassName: 'FixedRightBorder product' },
        ],
          TableIsEdit: true,
          PageSize: 10,
          OnPageChange: function(Index) {
              state.SearchEntity.PageIndex = Index;
              state.SearchPageData();
          },
          OnPageSizeOpts: function(pageSize) {
              state.SearchEntity.PageIndex = 1;
              state.SearchEntity.PageSize = pageSize;
              state.SearchPageData();
          },
          TableRowButtons: function() {

            
            var store = state
            if (store.Table2.$TableRowButtons) {
                return store.Table2.$TableRowButtons
            }

            var arr = [];

            // arr.push({
            //     nickName: g('$删除'), buttonType: 'error', type: 'ConfirmButton', forClick: function (data) {
            //         ProductTypeRequest.DeleteMallCart(function (d) {
            //             if (d.Message == "OK") {
            //                 store.Table.OnPageChange(store.SearchEntity.PageIndex, window.rootVue)
            //                 window.rootVue.$message.success(g("$操作成功"))
            //             } else {
            //                 window.rootVue.$message.error(d.Message)
            //             }
            //         }, {ID:data.ID})
            //     }
            // })
         

                arr.push({
                    nickName: g('$删除'),
                    buttonType: 'warning',
                    type: 'ConfirmButton',
                    // CheckShow: function(data) {
                    //     if (state.Entity.ID) {
                    //         if (state.Entity.Status != 0 || state.Entity.IsPay != 0) {
                    //             return false;
                    //         }
                    //     }
                    //     return true;
                    // },
                   
                    forClick: function(data) {
                     
                      ProductTypeRequest.DeleteMallCart(function(d) {
                        if (d.Message == "OK") {
                            // this.ShoppingPage.SearchPageData()
                            store.Table.OnPageChange(store.SearchEntity.PageIndex, vueObj)
                            vueObj.$message.success(g("$操作成功"))
                        } else {
                            vueObj.$message.error(d.Message)
                        }
                    }, data.ID) 

                    }
                })


              

            vueObj.$set(store.Table2, '$TableRowButtons', arr)
            return store.Table2.$TableRowButtons;

          },
      },
        FieldData: [{
                nickName: g('$所属客户'),
                field: 'UsersID',
                type: 'Select',
                error: '',
                isRequired: true,
                j: { rex: 'n', tips: g("${所属客户}为必填") },
                forSelectStoreName: GN('CustomerUsersID'),
                initField(vueObj, callback, data, field) {
                    if (data.ID) {
                        field.IsNotEdit = true;
                    } else {
                        field.IsNotEdit = false;
                    }
                },
                OnChange(v) {
                    var d = vueState[GN('CustomerUsersID')];
                    var f = new window.$LQ(d).First(function(e) { return e.ID == v });
                    if (f) {
                        GetFieldItem('SalesPrice', ShoppingPage.FieldData).AppendText = f.Account.Currency.EnName;
                        GetFieldItem('FixedFreight', ShoppingPage.FieldData).AppendText = f.Account.Currency.EnName;
                    } else {
                        GetFieldItem('SalesPrice', ShoppingPage.FieldData).AppendText = '';
                        GetFieldItem('FixedFreight', ShoppingPage.FieldData).AppendText = '';
                    }
                }
            },
            { nickName: g('$SKU'), field: 'SKU', type: 'String', IsNotEdit: true, error: '', isRequired: true },
            { nickName: g('$类型'), field: 'ProductTypeID', type: 'Select', error: '', isRequired: true, j: { rex: 'n', tips: g("${类型}为必填") }, forSelectStoreName: GN('ProductProductTypeID') },
            { nickName: g('$带电'), field: 'IsBattery', type: 'Select', error: '', isRequired: true, j: { rex: 'n', tips: g("${带电}为必填") }, forSelectStoreName: ('YesAndNo') },

            {
                nickName: g('$产品条形码'),
                field: 'ProductCode',
                type: 'String',
                error: '',
                initValue: " ",
                initField(vueObj, callback, data, field) {
                    if (!state.Entity || state.Entity.ID == 0 || !state.Entity.ID) {
                        field.IsNotEdit = true
                    }
                }
            },
            { nickName: g('$产品中文名'), field: 'CnName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${产品中文名}为必填") } },
            { nickName: g('$产品英文名'), field: 'EnName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${产品英文名}为必填") } },
            { nickName: g('$产品备注'), field: 'Remark', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${产品备注}为必填") } },
            { nickName: g('$采购价'), field: 'PurchasePrice', type: 'String', error: '', isRequired: true, j: { rex: 'd', tips: g("${采购价}为必填") } },
            { nickName: g('$销售价'), field: 'SalesPrice', type: 'String', AppendText: '', error: '', isRequired: true, j: { rex: 'd', tips: g("${销售价}为必填") } },
            // { nickName: g('$固定运费'), field: 'FixedFreight', type: 'String',AppendText:'', error: '', isRequired: true, j: { rex: 'd', tips: g("${固定运费}为必填") } },
            { nickName: g('$申报价值'), field: 'DeclaredValue', type: 'String', error: '', isRequired: true, j: { rex: 'd', tips: g("${申报价值}为必填") } },
            { nickName: g('$申报重量'), field: 'DeclareWeight', type: 'String', error: '', isRequired: true, j: { rex: 'd', tips: g("${申报重量}为必填") } },
            { nickName: g('$重量'), field: 'P_Weight', type: 'String', error: '', isRequired: true, j: { rex: 'd', tips: g("${重量}为必填") } },
            { nickName: g('$长'), field: 'P_Length', type: 'String', error: '', isRequired: true, j: { rex: 'd', tips: g("${长}为必填") } },
            { nickName: g('$宽'), field: 'P_Width', type: 'String', error: '', isRequired: true, j: { rex: 'd', tips: g("${宽}为必填") } },
            { nickName: g('$高'), field: 'P_Height', type: 'String', error: '', isRequired: true, j: { rex: 'd', tips: g("${高}为必填") } },
            { nickName: g('$海关编码'), field: 'CustomcCode', type: 'String', error: '' },
            { nickName: g('$产地'), field: 'ProducingArea', type: 'String', error: '' },
            { nickName: g('$图片地址'), field: 'ProductUrl', type: 'UploadImage', error: '', isRequired: true, buttonName: g("$上传"), j: { rex: 'w', tips: g("${图片地址}为必填") }, class: 'max300' },
        ],

        UploadProduct: {

            Table: {
                OnSelectionChange: function(selection) {
                    window.rootVue.$set(vueState, GN('UploadTableSelectCheckbox'), selection)
                },
                TableColumns: [{
                        nickName: ' ',
                        field: '',
                        type: 'selection',
                        width: 50,
                        fixed: 'left',
                        initValue: false,
                        forSelectStoreName: GN('UploadTableSelectCheckbox'),
                        Selectable(row, index) {
                            return vueState[GN('file_upload')] ? !vueState[GN('file_upload')].data[index].disabled : false;
                        }
                    },
                    { nickName: g('$_客户编码'), field: 'CusCode', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${_客户编码}为必填") } },
                    { nickName: g('$_图片链接'), field: 'ProductUrl', type: 'Image', error: '', isRequired: true, j: { rex: 'w', tips: g("${_客户编码}为必填") }, class: 'max100' },
                    { nickName: g('$_产品英文名'), field: 'EnName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${_产品英文名}为必填") } },
                    { nickName: g('$_产品中文名'), field: 'CnName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${_产品中文名}为必填") } },
                    //{ nickName: g('$_条形码'), field: 'ProductCode', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${_条形码}为必填") } },

                    { nickName: g('$_采购价'), field: 'PurchasePrice', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${_采购价}为必填") } },
                    { nickName: g('$_销售价'), field: 'SalesPrice', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${_销售价}为必填") } },
                    { nickName: g('$_申报价值'), field: 'DeclaredValue', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${_申报价值}为必填") } },
                    { nickName: g('$_申报重量'), field: 'DeclareWeight', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${_申报重量}为必填") } },
                    { nickName: g('$_产品类别'), field: 'ProductType', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${_产品类别}为必填") } },
                    { nickName: g('$_重量'), field: 'P_Weight', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${_重量}为必填") } },
                    { nickName: g('$_长'), field: 'P_Length', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${_长}为必填") } },
                    { nickName: g('$_宽'), field: 'P_Width', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${_宽}为必填") } },
                    { nickName: g('$_高'), field: 'P_Height', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${_高}为必填") } },
                    { nickName: g('$_海关编码'), field: 'CustomcCode', type: 'String', error: '', },
                    { nickName: g('$_原产地'), field: 'ProducingArea', type: 'String', error: '' },

                    { nickName: 'error', field: '__Error__', type: 'String', error: '', ClassName: "red" },
                ],
            },
            templateurl() {
                window.location = $Urlpath + "/Content/UploadTemplate/Products_upload_template.xls"
            },

            isInitUplaod: false,
            ModalName: g('$产品导入'),
            ModuleShow: false,
            initUplaod() {

                var store = state
                var vueObj = window.rootVue;

                if ($("#" + 'UploadProduct_file_upload label')[0]) {
                    return;
                }

                store.UploadProduct.isInitUplaod = true;
                $Upload($("#" + 'UploadProduct_file_upload'), function(file, data) {

                    var i = 0;
                    for (const e of data.data) {
                        e["__Error__"] = e["__Error__"] ? e["__Error__"] : "";

                        var r;
                        r = ObjectCheck({ rex: 'w', tips: g("${_产品英文名}为必填"), max: 300 }, e.EnName);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        e.BagsWeight_LB = ((e.BagsWeight ? e.BagsWeight : 0) * 2.2).toFixed(2);

                        r = ObjectCheck({ rex: 'w', tips: g("${_产品中文名}为必填"), max: 150 }, e.CnName);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'w', tips: g("${_英文申报品名}为必填") }, e.Remark);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'd', tips: g("${_采购价}为必填") }, e.PurchasePrice);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'd', tips: g("${_销售价}为必填") }, e.SalesPrice);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }


                        r = ObjectCheck({ rex: 'd', tips: g("${_申报价值}为必填") }, e.DeclaredValue);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }


                        r = ObjectCheck({ rex: 'd', tips: g("${_申报重量}为必填") }, e.DeclareWeight);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }


                        r = ObjectCheck({ rex: 'w', tips: g("${_产品类别}为必填") }, e.ProductType);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'd', tips: g("${_重量}为必填") }, e.P_Weight);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'd', tips: g("${_长}为必填") }, e.P_Length);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'd', tips: g("${_宽}为必填") }, e.P_Width);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'd', tips: g("${_高}为必填") }, e.P_Height);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        // r = ObjectCheck({ rex: 'w', tips: g("${_条形码}为必填") }, e.ProductCode);
                        // if (!r.IsCheck) {
                        //     e["__Error__"] += "," + r.error
                        // }

                        e.RID = i;
                        i++;
                        if (e["__Error__"]) {
                            e.disabled = true;
                        }
                    }

                    vueObj.$set(vueState, GN('file_upload'), data)

                }, $Urlpath + "/Upload/UploadProducts", $UploadSetting.Excel)

            },
            show() {
                state.UploadProduct.ModuleShow = true;
                setTimeout(function() {
                    state.UploadProduct.initUplaod()
                }, 500)
            }
        },


        initPageData() {
            vueObj = window.rootVue;

            var vueState = vueObj.$store.state;
            state = vueObj.$store.state[defaultStoreName];
            var store = state

            if (!store) {
                store = Clone(ShoppingPage);
                store.Entity = ToSubmitData(ToComponentData(ShoppingPage.FieldData))
                store.SearchEntity = ToSubmitData(ToComponentData(ShoppingPage.Search))
                store.IsInit = true;
                vueObj.$set(vueObj.$store.state, ShoppingPage.storeName, store)
            }

            state = store;
            return store
        },
        SearchPageData(callback) {

            if (!state.SearchEntity.PageSize) {
                state.SearchEntity.PageSize = ShoppingPage.Table.PageSize
            }

            if (!vueState[GN('SearchProduct')]) {
                vueObj.$set(vueState, GN("SearchProduct"), dc)
            }
           
            // state.SearchEntity.SearchType = 1;
            var Model ={
              ProductType: state.SearchEntity.ProductType,
              SKU: state.SearchEntity.SKU,
              Status: state.SearchEntity.Status,
            }
            state.SearchEntity.Model = Model
            // delete state.SearchEntity.ProductType
            // delete state.SearchEntity.SKU
            // delete state.SearchEntity.Status
            ProductTypeRequest.MallCartPaging(function(d) {
             
                vueObj.$set(vueState, GN("SearchProduct"), d)
                state.Table.$TableRowButtons = null;
                vueObj.$set(state.Table, '$TableRowButtons', state.Table.TableRowButtons())
                vueObj.$set(state, 'Table', Clone(state.Table))
                //客户端不显示采购价
                if( window.rootVue.$store.state.UserRights.UserContext.UserType==1){
                RemoveFieldItem('PurchasePrice', state.Table2.TableColumns)
                }
                // state.Table2.TableColumns.map(item=>{
                //     if(item.nickName=="采购价"){
                //         state.Table2.TableColumns.splice()
                //         RemoveFieldItem('Operation', this.ASN_PurchasesPage.Table2.TableColumns)
                //     }
                //     console.log(item.nickName,888888)
                // })
              
                if (callback) { callback(d) }
            }, state.SearchEntity)
            return vueState[GN('SearchProduct')]

            

            
        },
        initCustomerUsersID(callback) {


            userRequest.SearchUser(function(d) {
                // var store = state
                var arr = [{
                    Text: g("$公共"),
                    Value: 0
                }];

                for (var i of d.Records) {
                    i.Text = i.Customer.Name + ' - ' + i.Customer.CusCode;
                    i.Value = i.ID;
                    arr.push(i)
                }
                vueObj.$set(vueObj.$store.state, GN("CustomerUsersID"), arr)
                GetFieldItem('UsersID', ShoppingPage.FieldData).OnChange(store.Entity.UsersID);

                if (callback) { callback(d) }
            }, {
                PageSize: 10000,
                UserType: 1
            })

        },
        initProductTypeProductTypeID(callback) {
          var store = state
            ProductTypeRequest.SearchProductType(function(d) {
                var arr = [];
                var allType = {
                    ID:0,
                    CnName:"所有",
                    EnName:"All",

                }
                arr.unshift(allType)
                for (var i of d.Records) {
                    i.Text = i.EnName + "-" + i.CnName;
                    i.Value = i.ID;
                    arr.push(i)
                }
                store.typeList = arr
                // console.log(arr,store.typeList,8888)
                vueObj.$set(vueObj.$store.state, GN("ProductProductTypeID"), arr)
                if (callback) { callback(d) }
            }, {
                PageSize: 10000,
                Status: 1,
                IsSystem: true
            })
        },
    

        AddProducts(callback, data) {
            ProductRequest.AddProducts(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, data)
        },
        CopyProduct2Customer(callback, data) {
            ProductRequest.CopyProduct2Customer(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, data)
        },

        GetData(ID, callback) {
            if (ID == 0) {
                return;
            }
            ProductRequest.GetProduct(function(d) {
                var store = state
                vueObj.$set(store, 'Entity', d)
                GetFieldItem('UsersID', ShoppingPage.FieldData).OnChange(store.Entity.UsersID);
                if (callback) { callback(d) }
            }, ID)
        },
        Update: function(store, callback) {

            if (!store.Entity.ID) { //add
                var entity = ToSubmitEntity(store.Entity, store.FieldData);
                entity.Status = 1;
                if (CheckByEntity(entity, store.FieldData)) {
                    ProductRequest.AddProduct(function(d) {
                        if (d.Message == "OK") {
                            if (callback) { callback(d) }
                            vueObj.$message.success(g("$操作成功"))
                        } else {
                            vueObj.$message.error(d.Message)
                        }
                    }, entity)
                }
            } else { //update
                var entity = ToSubmitEntity(store.Entity, store.FieldData);
                if (CheckByEntity(entity, store.FieldData)) {
                    ProductRequest.UpdateProduct(function(d) {
                        if (d.Message == "OK") {
                            if (callback) { callback(d) }
                            vueObj.$message.success(g("$操作成功"))
                        } else {
                            vueObj.$message.error(d.Message)
                        }
                    }, entity)
                }
            }
        }
    }
    return ShoppingPage;
}


////////////////ProductConfig.js End//////////////////////s



// WEBPACK FOOTER //
// ./src/config/Warehouse/MyShoppingMallConfig.js